import { FC } from 'react'
import cn from 'classnames'
import styles from 'components/features/pfm/VerificationCodeHintBox/VerificationCodeHintBox.styl'

export const VerificationCodeHintBox: FC = () => {
  return (
    <div className={ styles.verificationCodeHintBox }>
      <div className={ styles.hintText }>
        Check your email for the verification code and enter it below.
      </div>
      <div className={ cn(styles.hintText, styles.warningText) }>
        Make sure to check your spam folder. If you find it there, please mark it as not spam.
      </div>
    </div>
  )
}
